import { CritType } from './CritType';

export class CritGroupPosition {
  critType: CritType;
  row: number;
  column: number;
}
